import { MagpieConnection } from 'magpie-lib/connection';
import { useAppDispatch } from '../../../hooks/redux';
import { navigationPublicApiTopicDef } from 'navigation-messaging/topics';
import { navVisibilityControls } from 'navigation-messaging/messages';
import { toolbarAndNavDisplayConfig } from '../../../overlayDisplayConfig/actions';
import { OverlayType } from '../../../overlayDisplayConfig/interface';
import { appOverlayDisplayConfig } from '../../../overlayDisplayConfig/actions';
import { useCallback, useEffect } from 'react';
import { useNavigationVisibility } from '../../../hooks/useNavigationVisibility';
const filter = ({
  senderFrameId
}, {
  frameId
}) => senderFrameId === frameId;

/**
 * Hook for handling navigation visibility via Public API
 * Manages both overlay display config for component rendering and dimensions for layout
 */
export const useVisibilityPublicApi = () => {
  const dispatch = useAppDispatch();
  const {
    setNavigationVisibility
  } = useNavigationVisibility();
  const onChangeNavVisibility = useCallback(({
    payload: {
      shouldShowToolbar,
      shouldShowVerticalNav,
      source
    }
  }, {
    reply
  }) => {
    const configureOverlayAction = appOverlayDisplayConfig({
      appName: source !== null && source !== void 0 ? source : null,
      [OverlayType.PUBLIC_API]: {
        shouldShowToolbar,
        shouldShowNav: shouldShowVerticalNav
      }
    });
    const displayOverlayAction = toolbarAndNavDisplayConfig({
      isOverlayOpen: true,
      overlayType: OverlayType.PUBLIC_API
    });
    dispatch(configureOverlayAction);
    dispatch(displayOverlayAction);
    setNavigationVisibility({
      isToolbarVisible: shouldShowToolbar,
      isVerticalNavVisible: shouldShowVerticalNav
    });
    const visibilityChanged = navVisibilityControls.navVisibilityChanged.create({
      isToolbarVisible: shouldShowToolbar,
      isVerticalNavVisible: shouldShowVerticalNav
    });
    reply(visibilityChanged);
  }, [dispatch, setNavigationVisibility]);
  useEffect(() => MagpieConnection.get().useTopic(navigationPublicApiTopicDef).on(navVisibilityControls.changeNavVisibility.getType(), onChangeNavVisibility, {
    filter
  }), [onChangeNavVisibility]);
  return {
    setNavigationVisibility
  };
};